import {Box, Fade, Tooltip, Typography} from "@mui/material";

function CellTitleValue({value, onClick}: {value: string, onClick?: () => void}) {
  return (
    <Box display="flex" alignItems="center" gap={8}>
      <Tooltip
        placement="bottom-start"
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 400 }}
        title={value}
        onDoubleClick={onClick}
      >
        <Typography sx={(theme) => ({
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          maxWidth: 300,
          fontWeight: 300,
          [theme.breakpoints.down('sm')]: {
            maxWidth: 150,
          }
        })}>
          {value}
        </Typography>
      </Tooltip>
    </Box>
  )
}

export default CellTitleValue
